import { InlineError as KiamaInlineError } from '@snsw/react-component-library';
import { Box, BoxProps } from 'components/Layout/Box';
import { PropsWithChildren } from 'react';
import styled from 'styled-components';

const Container = styled(Box)`
  span {
    padding-top: 2px;
  }
`;

/**
 * A thin wrapper around the Kiama `InlineError` component that corrects the padding around the exclamation point icon.
 *
 * @param errorMessage
 * @constructor
 */
export const InlineError = ({ children, ...layoutProps }: PropsWithChildren<BoxProps>) => {
  return (
    <Container {...layoutProps}>
      <KiamaInlineError errorMessage={children} />
    </Container>
  );
};
